module.exports = __webpack_public_path__ + "img/sim-original.9554d34a.png";